/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */

export type TrainerReviewProxyHomogenizedTypeEnum =
  (typeof TrainerReviewProxyHomogenizedTypeEnum)[keyof typeof TrainerReviewProxyHomogenizedTypeEnum];

export const TrainerReviewProxyHomogenizedTypeEnum = {
  trainerreview: 'trainerreview',
} as const;
